// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_Class_GraphRep = require("../Lunarbox.Data.Class.GraphRep/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Editor_Class_Depends = require("../Lunarbox.Data.Editor.Class.Depends/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Node = require("../Lunarbox.Data.Editor.Node/index.js");
var Lunarbox_Data_Editor_Node_NodeId = require("../Lunarbox.Data.Editor.Node.NodeId/index.js");
var Lunarbox_Data_Editor_Node_PinLocation = require("../Lunarbox.Data.Editor.Node.PinLocation/index.js");
var Lunarbox_Data_Graph = require("../Lunarbox.Data.Graph/index.js");
var Lunarbox_Data_Lens = require("../Lunarbox.Data.Lens/index.js");
var NodeGroup = function (x) {
    return x;
};
var showNodeGroup = Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "inputs";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "nodes";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "output";
}))(Data_Show.showRecordFieldsNil)(Lunarbox_Data_Editor_Node_NodeId.showNodeId))(Data_Map_Internal.showMap(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(Lunarbox_Data_Editor_Node.showNode)))(Data_List_Types.showList(Lunarbox_Data_Editor_Node_NodeId.showNodeId)));
var newtypeNodeGroup = new Data_Newtype.Newtype(function (n) {
    return n;
}, NodeGroup);
var encodeJsonNodeGroup = Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonList(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeMap(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId)(Lunarbox_Data_Editor_Node.encodeJsonNode))(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Editor_Node_NodeId.encodeJsonNodeId)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "output";
}))())(new Data_Symbol.IsSymbol(function () {
    return "nodes";
}))())(new Data_Symbol.IsSymbol(function () {
    return "inputs";
}))())();
var decodeJsonNodeGroup = Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeList(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeMap(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId)(Lunarbox_Data_Editor_Node.decodeJsonNode))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Editor_Node_NodeId.decodeJsonNodeId)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "output";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "nodes";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "inputs";
}))()())();
var compileNodeGroup = function (v) {
    var graph = Lunarbox_Data_Class_GraphRep.toGraph(Lunarbox_Data_Class_GraphRep.graphRepDependencyMap(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(Lunarbox_Data_Editor_Node.dependsNode))(v.nodes);
    var ordered = Lunarbox_Data_Graph.topologicalSort(Lunarbox_Data_Editor_Node_NodeId.ordNodeId)(graph);
    var bodyNodes = Data_Semigroup.append(Data_List_Types.semigroupList)(Data_List.difference(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(ordered)(new Data_List_Types.Cons(v.output, v.inputs)))(Control_Applicative.pure(Data_List_Types.applicativeList)(v.output));
    var $$return = Data_Foldable.foldr(Data_List_Types.foldableList)(Lunarbox_Data_Editor_Node.compileNode(graph))(new Lunarbox_Data_Dataflow_Expression.TypedHole(Lunarbox_Data_Editor_Node_PinLocation.PlaceholderPosition.value))(bodyNodes);
    return Lunarbox_Data_Dataflow_Expression.functionDeclaration(Lunarbox_Data_Editor_Node_PinLocation.FunctionDeclaration.value)($$return)(Data_Functor.map(Data_List_Types.functorList)(Data_Functor.map(Data_Functor.functorFn)(Lunarbox_Data_Dataflow_Expression.VarName)(Data_Newtype.unwrap(Lunarbox_Data_Editor_Node_NodeId.newtypeNodeId)))(v.inputs));
};
var _NodeGroupOutput = function (dictStrong) {
    var $15 = Lunarbox_Data_Lens.newtypeIso(newtypeNodeGroup)(dictStrong);
    var $16 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "output";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($17) {
        return $15($16($17));
    };
};
var _NodeGroupNodes = function (dictStrong) {
    var $18 = Lunarbox_Data_Lens.newtypeIso(newtypeNodeGroup)(dictStrong);
    var $19 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "nodes";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($20) {
        return $18($19($20));
    };
};
var dependencyNodeGroup = new Lunarbox_Data_Editor_Class_Depends.Depends((function () {
    var $21 = Data_Foldable.foldMap(Data_Map_Internal.foldableMap)(Data_Set.monoidSet(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(function (v) {
        if (v instanceof Lunarbox_Data_Editor_Node.ComplexNode) {
            return Data_Set.singleton(v["value0"]["function"]);
        };
        return Data_Monoid.mempty(Data_Set.monoidSet(Lunarbox_Data_Editor_FunctionName.ordFunctionName));
    });
    var $22 = Data_Lens_Getter.view(_NodeGroupNodes(Data_Lens_Internal_Forget.strongForget));
    return function ($23) {
        return $21($22($23));
    };
})());
var _NodeGroupInputs = function (dictStrong) {
    var $24 = Lunarbox_Data_Lens.newtypeIso(newtypeNodeGroup)(dictStrong);
    var $25 = Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "inputs";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
    return function ($26) {
        return $24($25($26));
    };
};
module.exports = {
    NodeGroup: NodeGroup,
    compileNodeGroup: compileNodeGroup,
    "_NodeGroupInputs": _NodeGroupInputs,
    "_NodeGroupOutput": _NodeGroupOutput,
    "_NodeGroupNodes": _NodeGroupNodes,
    newtypeNodeGroup: newtypeNodeGroup,
    showNodeGroup: showNodeGroup,
    encodeJsonNodeGroup: encodeJsonNodeGroup,
    decodeJsonNodeGroup: decodeJsonNodeGroup,
    dependencyNodeGroup: dependencyNodeGroup
};
